// ================================= ABOUT US ================================

window.PrepareAboutUsUI = function()
{
    document.getElementById("AboutUsHeaderText").innerHTML = window["AboutUsTxt" + window.CurrentCountryID];
    document.getElementById("AboutUsTopMessageText").innerHTML = window["AboutUsTopMessageTxt" + window.CurrentCountryID];

    document.getElementById("AboutPinginGoHeaderText").innerHTML = window["AboutPinginGoTxt" + window.CurrentCountryID];

    document.getElementById("AboutPinginGoMessageText1").innerHTML = window["AboutMessage1Txt" + window.CurrentCountryID];
    document.getElementById("AboutPinginGoMessageText2").innerHTML = window["AboutMessage2Txt" + window.CurrentCountryID];
    document.getElementById("AboutPinginGoMessageText3").innerHTML = window["AboutMessage3Txt" + window.CurrentCountryID];
    document.getElementById("AboutPinginGoMessageText4").innerHTML = window["AboutMessage4Txt" + window.CurrentCountryID];
}

// ================================= CONTACT US ================================

var RedSendErrorContainer;
var RedSendErrorText;

var ContactUsYourNameInputContainer;
var ContactUsYourNameInputField;
var ContactUsYourNameWarning;

var ContactUsCompanyInputContainer;
var ContactUsCompanyInputField;
var ContactUsCompanyWarning;

var ContactUsPhoneNumberInputContainer;
var ContactUsPhoneNumberInputField;
var ContactUsPhoneNumberWarning;

var ContactUsYourEmailInputContainer;
var ContactUsYourEmailInputField;
var ContactUsYourEmailWarning;

var ContactUsYourMessageInputContainer;
var ContactUsYourMessageInputField;
var ContactUsYourMessageWarning;

var SendMessageButtonContactUs;


window.PrepareContactUsUI = function()
{
    RedSendErrorContainer = document.getElementById("RedSendErrorContainer");
    RedSendErrorText = document.getElementById("RedSendErrorText");

    // ----------------------

    document.getElementById("ContactUsHeaderText").innerHTML = window["ContactUsHeaderTxt" + window.CurrentCountryID];
    document.getElementById("ContactUsMessageText").innerHTML = window["ContactUsMessageTxt" + window.CurrentCountryID];
    
    document.getElementById("SendUsAMessageHeaderText").innerHTML = window["SendUsMsgHeaderTxt" + window.CurrentCountryID];

    // Your Name -------------
    document.getElementById("ContactUsYourNameHeaderText").innerHTML = window["YourNameTxt" + window.CurrentCountryID];
    ContactUsYourNameInputContainer = document.getElementById("ContactUsYourNameInputContainer");
    ContactUsYourNameInputField = document.getElementById("ContactUsYourNameInputField");
    ContactUsYourNameWarning = document.getElementById("ContactUsYourNameWarning");

    // Company -------------
    document.getElementById("ContactUsCompanyHeaderText").innerHTML = window["CompanyTxt" + window.CurrentCountryID];
    ContactUsCompanyInputContainer = document.getElementById("ContactUsCompanyInputContainer");
    ContactUsCompanyInputField = document.getElementById("ContactUsCompanyInputField");
    ContactUsCompanyWarning = document.getElementById("ContactUsCompanyWarning");

    // Phone Number -------------
    document.getElementById("ContactUsPhoneNumberHeaderText").innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID];
    ContactUsPhoneNumberInputContainer = document.getElementById("ContactUsPhoneNumberInputContainer");
    ContactUsPhoneNumberInputField = document.getElementById("ContactUsPhoneNumberInputField");
    ContactUsPhoneNumberWarning = document.getElementById("ContactUsPhoneNumberWarning");

    // Email Address -------------
    document.getElementById("ContactUsYourEmailHeaderText").innerHTML = window["EmailTxt" + window.CurrentCountryID];
    ContactUsYourEmailInputContainer = document.getElementById("ContactUsYourEmailInputContainer");
    ContactUsYourEmailInputField = document.getElementById("ContactUsYourEmailInputField");
    ContactUsYourEmailWarning = document.getElementById("ContactUsYourEmailWarning");

    // Message -------------
    document.getElementById("ContactUsYourMessageHeaderText").innerHTML = window["MessageTxt" + window.CurrentCountryID];
    ContactUsYourMessageInputContainer = document.getElementById("ContactUsYourMessageInputContainer");
    ContactUsYourMessageInputField = document.getElementById("ContactUsYourMessageInputField");
    ContactUsYourMessageInputField.placeholder = window["InputMessageContactUsPlaceHolderTxt" + window.CurrentCountryID];
    ContactUsYourMessageWarning = document.getElementById("ContactUsYourMessageWarning");

    // Send Message -------------
    SendMessageButtonContactUs = document.getElementById("SendMessageButtonContactUs");
    document.getElementById("SendMessageButtonTextContactUs").innerHTML = window["SendMessageButtonTxt" + window.CurrentCountryID];

    // Header Contact Us -------------

    document.getElementById("ContactInformationHeaderText").innerHTML = window["ContactInformationHeaderTxt" + window.CurrentCountryID];

    // Chat on WhatsApp -------------
    document.getElementById("ChatOnWhatsAppButtonText").innerHTML = window["ChatOnWhatsAppButtonTxt" + window.CurrentCountryID];


    // Add Function ----------------------------

    ContactUsYourNameInputField.onfocus = function(event) // Your Name -------------
    {
        RedSendErrorContainer.style.display = "none";
        ContactUsYourNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        ContactUsYourNameWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable";
    }
    ContactUsYourNameInputField.addEventListener("focusout", (event) =>
    {
        CheckInputtedContactUs(true);
    });


    ContactUsCompanyInputField.onfocus = function(event) // Company -------------
    {
        RedSendErrorContainer.style.display = "none";
        ContactUsCompanyInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        ContactUsCompanyWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable";
    }
    ContactUsCompanyInputField.addEventListener("focusout", (event) =>
    {
        CheckInputtedContactUs(true);
    });

    ContactUsPhoneNumberInputField.onfocus = function(event) // Phone Number -------------
    {
        RedSendErrorContainer.style.display = "none";
        ContactUsPhoneNumberInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        ContactUsPhoneNumberWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable";
    }
    ContactUsPhoneNumberInputField.onkeyup = function()
    {
        let allowedPattern = "0-9+";
        window.CheckInputAllowed(ContactUsPhoneNumberInputField, allowedPattern);
    }
    ContactUsPhoneNumberInputField.addEventListener("focusout", (event) =>
    {
        CheckInputtedContactUs(true);
    });

    ContactUsYourEmailInputField.onfocus = function(event) // Email -------------
    {
        RedSendErrorContainer.style.display = "none";
        ContactUsYourEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
        ContactUsYourEmailWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable";
    }
    ContactUsYourEmailInputField.addEventListener("focusout", (event) =>
    {
        CheckInputtedContactUs(true);
    });

    ContactUsYourMessageInputField.onfocus = function(event) // Message -------------
    {
        RedSendErrorContainer.style.display = "none";
        ContactUsYourMessageInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        ContactUsYourMessageWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable";
    }
    ContactUsYourMessageInputField.addEventListener("focusout", (event) =>
    {
        CheckInputtedContactUs(true);
    });

    CheckInputtedContactUs(false);
}

function CheckInputtedContactUs(isallowchange)
{
    let IsError = false;

    // Your Name -------------
    if(ContactUsYourNameInputField.value == "" || ContactUsYourNameInputField.value.replace(/ /g, "") == "")
    {
        IsError = true;
        if(isallowchange == true)
        {
            ContactUsYourNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            ContactUsYourNameWarning.className = "RedWarningText InterMediumTextFont";
            ContactUsYourNameWarning.innerHTML = window["YourNameCannotEmptyTxt" + window.CurrentCountryID];
        }
    }

    // Company -------------
    // if(ContactUsCompanyInputField.value == "" || ContactUsCompanyInputField.value.replace(/ /g, "") == "")
    // {
    //     IsError = true;
    //     if(isallowchange == true)
    //     {
    //         ContactUsCompanyInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
    //         ContactUsCompanyWarning.className = "RedWarningText InterMediumTextFont";
    //         ContactUsCompanyWarning.innerHTML = window["CompanyCannotEmptyTxt" + window.CurrentCountryID];
    //     }
    // }

    // Phone Number -------------
    if(ContactUsPhoneNumberInputField.value == "" || ContactUsPhoneNumberInputField.value.replace(/ /g, "") == "")
    {
        IsError = true;
        if(isallowchange == true)
        {
            ContactUsPhoneNumberInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            ContactUsPhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
            ContactUsPhoneNumberWarning.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
        }
    }

    // Email -------------
    if(ContactUsYourEmailInputField.value == "" || ContactUsYourEmailInputField.value.replace(/ /g, "") == "" || window.CheckEmailValidity(ContactUsYourEmailInputField.value) == false)
    {
        IsError = true;
        if(isallowchange == true)
        {
            ContactUsYourEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            ContactUsYourEmailWarning.className = "RedWarningText InterMediumTextFont";

            if(window.CheckEmailValidity(ContactUsYourEmailInputField.value) == false)
            {
                ContactUsYourEmailWarning.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
            }
            else
            {
                ContactUsYourEmailWarning.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
            }
        }
    }

    // Message -------------
    if(ContactUsYourMessageInputField.value == "" || ContactUsYourMessageInputField.value.replace(/ /g, "") == "")
    {
        IsError = true;
        if(isallowchange == true)
        {
            ContactUsYourMessageInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            ContactUsYourMessageWarning.className = "RedWarningText InterMediumTextFont";
            ContactUsYourMessageWarning.innerHTML = window["MessageCannotEmptyTxt" + window.CurrentCountryID];
        }
    }

    // Final ------------------------

    if(IsError == true)
    {
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable";
        SendMessageButtonContactUs.onclick = function(){};
    }
    else
    {
        SendMessageButtonContactUs.className = "BasicTextButton OrangeButton SignInButtonTop Selectable";
        SendMessageButtonContactUs.onclick = function(event)
        {
            window.event.preventDefault();
            window.event.stopPropagation();

            SendContactUsMessage();
        }
    }
}


// Send Message -----------------------------------------------------------------------------------

function SendContactUsMessage()
{
    let LoadingBlocker = window.InstantiateLoadingBlocker("SendContactUsBlocker");

    let UserNameInfo = ContactUsYourNameInputField.value;
    let UserCompanyInfo = ContactUsCompanyInputField.value;
    let UserPhoneInfo = ContactUsPhoneNumberInputField.value;
    let UserEmailInfo = ContactUsYourEmailInputField.value;
    let UserMessage = ContactUsYourMessageInputField.value;

    let formData = new FormData();
    formData.append('name', UserNameInfo);
    formData.append('company', UserCompanyInfo);
    formData.append('phone_number', UserPhoneInfo);
    formData.append('email', UserEmailInfo);
    formData.append('message', UserMessage);

    RedSendErrorContainer.style.backgroundColor = "#C00000";
    RedSendErrorText.innerHTML = window["ErrorWhenSendingMessageTxt" + window.CurrentCountryID];

    let URLSendMessageCollab = "/v2/collab/";
    //console.log(URLSendMessageCollab);
    //console.log(window.ConvertFormDataToJSON(formData));

    window.CallApiAxios({
        method: "POST",
        url: URLSendMessageCollab,
        data: formData
    }).then(res =>
    {
        //console.log(res);

        if(res.status == 201)
        {
            RedSendErrorContainer.style.backgroundColor = "#00ab56";
            RedSendErrorText.innerHTML = window["SuccessSendMessageTxt" + window.CurrentCountryID];

            ContactUsYourNameInputField.value = "";
            ContactUsCompanyInputField.value = "";
            ContactUsPhoneNumberInputField.value = "";
            ContactUsYourEmailInputField.value = "";
            ContactUsYourMessageInputField.value = "";

            CheckInputtedContactUs(false);
        }

        LoadingBlocker.remove();
        RedSendErrorContainer.style.display = "";
    })
    .catch(err =>
    {
        //console.error(err);
        LoadingBlocker.remove();
        RedSendErrorContainer.style.display = "";
    });
}


//===================================== TERMS AND CONDITION =====================================

window.PrepareTermsConditionUI = function()
{
    document.getElementById("TermsAndConditionHeaderTopText").innerHTML = window["TermsNCondition2Txt" + window.CurrentCountryID];
    document.getElementById("TermsAndConditionHeaderText").innerHTML = window["TermsNCondition2Txt" + window.CurrentCountryID];
}

//===================================== PRIVACY =====================================

window.PreparePrivacyUI = function()
{
    document.getElementById("PrivacyHeaderTopText").innerHTML = window["PrivacyTxt" + window.CurrentCountryID];
    document.getElementById("PrivacyHeaderText").innerHTML = window["PrivacyTxt" + window.CurrentCountryID];

    document.getElementById("PernyataanCookieHeaderText").innerHTML = window["PernyataanCookieTxt" + window.CurrentCountryID];
}

//===================================== FAQ =====================================

window.PrepareFAQUI = function()
{
    document.getElementById("FAQHeaderText").innerHTML = window["FAQ2Txt" + window.CurrentCountryID];
    document.getElementById("FAQMessageText").innerHTML = window["HowCanWeHelpYouTxt" + window.CurrentCountryID];
    document.getElementById("HowCanWeHelpYouHeaderText").innerHTML = window["HowCanWeHelpYouTxt" + window.CurrentCountryID];
    document.getElementById("PopularQuestionMessageText").innerHTML = window["PopularQuestionTxt" + window.CurrentCountryID];
}
